import "./TabelaHistoricoDeLeituraAluno.css";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { historicoAluno } from "../services/api";
import Tabela from "../tabelas/Tabela";
import lupa from "../imagem/lupa.svg";
import iconOlhoAberto from "../imagem/iconVisualizar.svg";
import iconEstrelaAvaliacao from "../imagem/iconEstrelaAvaliacao.svg";
import ModalInfoLivro from "../modais/ModalInfoLivro";
import Avaliacao from "../modais/Avaliacao";

export default function TabelaHistoricoDeLeituraAluno() {
  const [dadosHistoricoDeLeitura, setDadosHistoricoDeLeitura] = useState([]);
  const [
    dadosFormatadosHistoricoDeLeitura,
    setDadosFormatadosHistoricoDeLeitura,
  ] = useState([]);

  const [inputFiltro, setInputFiltro] = useState("");

  const [paginandoTabela, setPaginandoTabela] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState();

  const [carregandoPagina, setCarregandoPagina] = useState(false);
  const [atualizarDados, setAtualizarDados] = useState(false);

  const [modalVisualizarLivro, setModalVisualizarLivro] = useState(false);
  const [modalAvaliacao, setModalAvaliacao] = useState(false);

  const [objLivro, setObjLivro] = useState();

  const colunasTabelaHistoricoDeLeituraAluno = [
    "titulo",
    "emprestimo",
    "devolucao",
    "pontuacao",
    "acoes",
  ];

  const estiloTabelaHistoricoDeLeituraAluno = {
    height: "130%",
    width: "100%",
    margin: "0 auto",
    border: "1px solid var(--cor-cinzaMargin)",
    borderRadius: 2,
  };

  useEffect(() => {
    carregarDados();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    formataDadosHistoricoDeLeitura();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dadosHistoricoDeLeitura]);

  useEffect(() => {
    if (inputFiltro === "") {
      carregarDados();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputFiltro]);

  useEffect(() => {
    if (atualizarDados) {
      carregarDados();
      setAtualizarDados(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [atualizarDados]);

  async function carregarDados(pagina = 1, limite = 10) {
    try {
      setCarregandoPagina(true);
      const objHistoricoAluno = {
        limite: limite,
        pagina: pagina,
        nome: inputFiltro,
      };
      const { data } = await historicoAluno(objHistoricoAluno);
      setDadosHistoricoDeLeitura(data.content || []);
      setPaginandoTabela(data.totalPages || 0);
      setTotalPaginas(data.totalPages);
    } catch (error) {
    } finally {
      setCarregandoPagina(false);
    }
  }

  function formataDadosHistoricoDeLeitura() {
    const objRetorno = [];
    dadosHistoricoDeLeitura?.map((c) =>
      objRetorno.push({
        id: c.idLivro,

        idEmprestimo: c.idEmprestimo,

        titulo:
          c.titulo.length > 32 ? c?.titulo.slice(0, 32) + "..." : c?.titulo,

        autor: c?.autor,

        anoPublicacao: c?.anoPublicacao,

        genero: c?.genero,

        quantidadeLivros: c?.livrosDisponiveis,

        sinopse: c?.sinopse,

        emprestimo: c?.dataEmprestimo,

        pontuacao: c.pontuacao === 0 ? "Livro não avaliado" : c?.pontuacao,

        dataAvaliacao: c.dataAvaliacao,

        devolucao: c?.dataDevolucao,

        resenha: c?.resenha,

        quantidadeEstrelas: c?.quantidadeEstrelas,

        mediaEstrelas: c.mediaEstrelas,

        quantidadeAvaliacoes: c.quantidadeAvaliacoes,

        favoritado: c.favoritado
      })
    );
    setDadosFormatadosHistoricoDeLeitura(objRetorno);
  }

  function clickPaginacao(event, value) {
    carregarDados(value);
  }

  function openModalVisualizarLivro(livro) {
    setModalVisualizarLivro(true);
    setObjLivro(livro);
  }

  function openModalAvaliacao(livro) {
    setModalAvaliacao(true);
    setObjLivro(livro);
  }

  const acoes = [
    {
      texto: "Avaliar",
      icon: iconEstrelaAvaliacao,
      func: openModalAvaliacao,
    },
    {
      texto: "Visualizar livro",
      icon: iconOlhoAberto,
      func: openModalVisualizarLivro,
    },
  ];

  return (
    <div className="container_historicoDeLeituraAluno ">
      <ToastContainer />
      <ModalInfoLivro
        abrirModal={modalVisualizarLivro}
        fecharModal={() => setModalVisualizarLivro(false)}
        nome={objLivro?.titulo}
        sinopse={objLivro?.sinopse}
        data={objLivro?.anoPublicacao}
        genero={objLivro?.genero}
        livrosDisponiveis={objLivro?.quantidadeLivros}
        quantidadeAvaliacoes={objLivro?.quantidadeAvaliacoes}
        avaliacao={objLivro?.mediaEstrelas}
        autor={objLivro?.autor}
        favorito={objLivro?.favoritado}
        idLivro={objLivro?.id}
      />
      <Avaliacao
        abrirModalAvaliacao={modalAvaliacao}
        fecharModalAvaliacao={() => setModalAvaliacao(false)}
        id={objLivro?.idEmprestimo}
        nome={objLivro?.titulo}
        titulo={objLivro?.titulo}
        emprestimo={objLivro?.emprestimo}
        devolucao={objLivro?.devolucao}
        pontuacao={objLivro?.pontuacao}
        atualizarPontuacao={() => setAtualizarDados(true)}
        dataAvaliacao={objLivro?.dataAvaliacao}
        resenha={objLivro?.resenha}
        valorQntdEstrela={objLivro?.quantidadeEstrelas}
      />
      <h2>Histórico de leitura</h2>
      <>
        <div className="caixa_buscar">
          <input
            id="input_historicoDeLeitura" // mudei nome
            value={inputFiltro}
            type="text"
            placeholder="Buscar"
            className="input_tabelaHistoricoDeLeitura"
            onChange={(e) => setInputFiltro(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                carregarDados();
              }
            }}
          />
          <button className="btn_pesquisar" onClick={() => carregarDados()}>
            <img src={lupa} alt="lupa" />
          </button>
        </div>

        <div className="div_tabela">
          {dadosFormatadosHistoricoDeLeitura.length === 0 ? (
            <div className="msg_dadoNaoEncontrado">
              <span>Nenhum dado encontrado.</span>
            </div>
          ) : (
            <Tabela
              dados={dadosFormatadosHistoricoDeLeitura}
              colunas={colunasTabelaHistoricoDeLeituraAluno}
              estiloTabela={estiloTabelaHistoricoDeLeituraAluno}
              qtdPaginas={totalPaginas}
              clickPaginacao={clickPaginacao}
              acoes={acoes}
              carregandoPagina={carregandoPagina}
            />
          )}
        </div>
      </>
    </div>
  );
}
